// extracted by mini-css-extract-plugin
export default {"window":"_53h1MyK9mLhgMJGnmUGoEA"};